import React, { useState } from "react";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة المنوال، الوسيط، المدى، المتوسط، المتوسط الهندسي";
const DESCRIPTION =
  "تحسب هذه الآلة الحاسبة المتوسط، الوسيط، المنوال، المدى، المتوسط الهندسي، أكبر عدد، أصغر عدد، مجموع الأعداد، عدد الأرقام، وترتيب البيانات ";
const KEYWORDS = "إحصاءات، متوسط، وسيط، منوال، مدى، متوسط هندسي، حاسبة";
const OG_URL = "https://do-calculate.com/calculator/ar/mean-median-mode-range-calculator";
const StatisticsCalculator = () => {
  const [numbers, setNumbers] = useState("");
  const [mean, setMean] = useState(null);
  const [median, setMedian] = useState(null);
  const [mode, setMode] = useState(null);
  const [range, setRange] = useState(null);
  const [geometricMean, setGeometricMean] = useState(null);
  const [largest, setLargest] = useState(null);
  const [smallest, setSmallest] = useState(null);
  const [sum, setSum] = useState(null);
  const [count, setCount] = useState(null);
  const [sorted, setSorted] = useState([]);
  const [error, setError] = useState("");
  const calculateMean = (numArray) => {
    const total = numArray.reduce((acc, num) => acc + num, 0);
    return (total / numArray.length).toFixed(2);
  };
  const calculateMedian = (numArray) => {
    const sortedNums = [...numArray].sort((a, b) => a - b);
    const mid = Math.floor(numArray.length / 2);
    return (
      numArray.length % 2 !== 0
        ? sortedNums[mid]
        : (sortedNums[mid - 1] + sortedNums[mid]) / 2
    ).toFixed(2);
  };
  const calculateMode = (numArray) => {
    const frequency = {};
    numArray.forEach((num) => {
      frequency[num] = (frequency[num] || 0) + 1;
    });
    const modeArray = Object.keys(frequency).filter(
      (key) => frequency[key] === Math.max(...Object.values(frequency))
    );
    return modeArray.length === numArray.length
      ? "لا يوجد منوال"
      : modeArray.join(", ");
  };
  const calculateRange = (numArray) => {
    return (Math.max(...numArray) - Math.min(...numArray)).toFixed(2);
  };
  const calculateGeometricMean = (numArray) => {
    const product = numArray.reduce((acc, num) => acc * num, 1);
    return Math.pow(product, 1 / numArray.length).toFixed(2);
  };
  const handleCalculate = () => {
    try {
      if (!numbers) {
        throw new Error("الرجاء إدخال أرقام مفصولة بفواصل.");
      }
      const numArray = numbers.split(",").map(Number);
      if (numArray.some(isNaN))
        throw new Error("الرجاء إدخال أرقام صحيحة مفصولة بفواصل.");
      const sortedNums = [...numArray].sort((a, b) => a - b);
      const meanValue = calculateMean(numArray);
      const medianValue = calculateMedian(numArray);
      const modeValue = calculateMode(numArray);
      const rangeValue = calculateRange(numArray);
      const geometricMeanValue = calculateGeometricMean(numArray);
      const largestValue = Math.max(...numArray);
      const smallestValue = Math.min(...numArray);
      const sumValue = numArray.reduce((acc, num) => acc + num, 0);
      const countValue = numArray.length;
      setMean(meanValue);
      setMedian(medianValue);
      setMode(modeValue);
      setRange(rangeValue);
      setGeometricMean(geometricMeanValue);
      setLargest(largestValue);
      setSmallest(smallestValue);
      setSum(sumValue);
      setCount(countValue);
      setSorted(sortedNums);
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  استخدم هذه الآلة الحاسبة المتقدمة للحصول على تحليل دقيق
                  لمجموعة واسعة من الإحصائيات حول بياناتك. هذه الأداة القوية
                  تمكنك من حساب:
                </p>
                <ul>
                  <li>
                    <b>المتوسط</b>: حساب متوسط مجموعة الأرقام. على سبيل المثال،
                    لمجموعة الأرقام (4, 8, 15, 16, 23, 42)، يكون المتوسط 18.67.
                  </li>
                  <li>
                    <b>الوسيط</b>: الرقم الذي يقع في المنتصف عند ترتيب الأرقام
                    تصاعديًا. بالنسبة لمجموعة الأرقام (4, 8, 15, 16, 23, 42)،
                    يكون الوسيط 15.
                  </li>
                  <li>
                    <b>المنوال</b>: الرقم الأكثر تكرارًا في مجموعة البيانات.
                    يساعدك في معرفة القيم الشائعة.
                  </li>
                  <li>
                    <b>المدى</b>: الفرق بين أكبر وأصغر عدد. لحساب المدى لمجموعة
                    '(3, 7, 5, 10)، تكون النتيجة 7.
                  </li>
                  <li>
                    <b>المتوسط الهندسي</b>: يُستخدم لتقييم النمو أو التغيرات
                    النسبية.
                  </li>
                  <li>
                    <b>أكبر عدد</b>: يعرض أكبر قيمة في مجموعة البيانات.
                  </li>
                  <li>
                    <b>أصغر عدد</b>: يعرض أصغر قيمة في مجموعة البيانات.
                  </li>
                  <li>
                    <b>مجموع الأعداد</b>: مجموع كافة الأرقام في المجموعة.
                  </li>
                  <li>
                    <b>عدد الأرقام</b>: عدد القيم الموجودة في مجموعة البيانات.
                  </li>
                  <li>
                    <b>ترتيب البيانات</b>: ترتيب الأرقام تصاعديًا أو تنازليًا.
                  </li>
                </ul>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          أدخل الأرقام مفصولة بفواصل
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="مثال: 1, 2, 3, 4"
                        value={numbers}
                        onChange={(e) => setNumbers(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  <div>
                    { error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      mean !== null && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <p className=" text-white">المتوسط: {mean}</p>
                          <p className=" text-white">الوسيط: {median}</p>
                          <p className=" text-white">المنوال: {mode}</p>
                          <p className=" text-white">المدى: {range}</p>
                          <p className=" text-white">
                            المتوسط الهندسي: {geometricMean}
                          </p>
                          <p className=" text-white">أكبر عدد: {largest}</p>
                          <p className=" text-white">أصغر عدد: {smallest}</p>
                          <p className=" text-white">مجموع الأعداد: {sum}</p>
                          <p className=" text-white">عدد الأرقام: {count}</p>
                          <p className=" text-white">
                            ترتيب الأرقام: {sorted.join(", ")}
                          </p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>المتوسط</h3>
            </div>
            <div className="info-section-body">
              <p>
                كلمة "المتوسط" في الرياضيات تشير عادةً إلى "المتوسط الحسابي".
                المتوسط الحسابي هو القيمة التي نحصل عليها بقسمة مجموع الأعداد
                على عددها. يساعد المتوسط في فهم البيانات بشكل أفضل.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>الوسيط</h3>
            </div>
            <div className="info-section-body">
              <p>
                الوسيط هو القيمة التي تقسم مجموعة من البيانات إلى نصفين
                متساويين. يتم ترتيب الأعداد في تسلسل تصاعدي ثم يتم تحديد الوسيط
                بناءً على عدد الأرقام. في حالة عدد فردي من الأرقام، يكون الوسيط
                هو الرقم الموجود في المنتصف. إذا كان العدد زوجيًا، فإن الوسيط هو
                متوسط الرقمين الموجودين في المنتصف.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>المنوال</h3>
            </div>
            <div className="info-section-body">
              <p>
                المنوال هو القيمة الأكثر تكرارًا في مجموعة من البيانات. قد يكون
                هناك أكثر من منوال واحد إذا تكرر أكثر من رقم بنفس العدد. يساعد
                المنوال في تحديد القيم الشائعة في البيانات.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>المدى</h3>
            </div>
            <div className="info-section-body">
              <p>
                المدى هو الفرق بين أكبر وأصغر قيمة في مجموعة من البيانات. يساعد
                المدى في فهم مدى تشتت البيانات.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default StatisticsCalculator;
